// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2BOYM","paramInput":"JobSimulator_paramInput__37Km8","input":"JobSimulator_input__gnmQt"};